import { ReactNode } from "react";

export const TxTitle = ({ children }: { children: ReactNode }) => {
    return <div data-testid="tx-title">{children}</div>;
};
